// src/pages/Kundenliste.jsx ///
import { useEffect, useState } from "react";
import {
    Box,
    Heading,
    Input,
    Flex,
    Text,
    VStack,
    HStack,
} from "@chakra-ui/react";
import axios from "axios";
import { IconButton } from "@chakra-ui/react";
import { Search, Pencil, Trash } from "lucide-react";

export default function Kundenliste() {
    const [kunden, setKunden] = useState([]);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/kunden`)
            .then((res) => {
                const sorted = res.data.sort((a, b) =>
                    a.nachname.localeCompare(b.nachname)
                );
                setKunden(sorted);
            })
            .catch((err) => console.error("Error loading Kunden:", err));
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Kunde wirklich löschen?")) {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/kunden/${id}`);
            setKunden((prev) => prev.filter((k) => k.id !== id));
        }
    };

    const filteredKunden = kunden.filter((k) =>
        k.nachname.toLowerCase().startsWith(filter.toLowerCase())
    );

    return (
        <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
            <Heading size="md" mb={4}>Kundenliste</Heading>

            <Input
                placeholder="Filtern nach Name"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                mb={6}
            />

            <VStack align="stretch" spacing={3}>
                {filteredKunden.map((kunde) => (
                    <Flex key={kunde.id} justify="space-between" align="center" p={3} borderWidth="1px" borderRadius="md">
                        <Text fontWeight="semibold" color="blue.600">
                            {kunde.firma ? (
                                <>
                                    <span style={{ textDecoration: "underline" }}>
                                    {kunde.firma}
                                    </span>
                                    <br />
                                    <span style={{ color: "black" }}>
                                    {kunde.nachname} {kunde.vorname}
                                    </span>
                                </>
                            ) : (
                                <>
                                <span style={{ color: "black" }}>
                                    {kunde.nachname} {kunde.vorname}
                                    </span>
                                </>
                            )}
                        </Text>
                        <HStack>
                            <IconButton
                                aria-label="View"
                                colorPalette="blue"
                                onClick={() => (window.location.href = `/systemdaten/kunden/${kunde.id}`)}
                            >
                                <Search size={18} />
                            </IconButton>
                            <IconButton
                                aria-label="Edit"
                                colorPalette="green"
                                onClick={() => (window.location.href = `/systemdaten/kunden/edit/${kunde.id}`)}
                            >
                                <Pencil size={18} />
                            </IconButton>
                            <IconButton
                                aria-label="Delete"
                                colorPalette="red"
                                onClick={() => handleDelete(kunde.id)}
                            >
                                <Trash size={18} />
                            </IconButton>
                        </HStack>
                    </Flex>
                ))}
            </VStack>
        </Box>
    );
}